module.exports = __webpack_public_path__ + "static/media/image3.176e8003.jpg";